
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nutritional-advisors",
      function () {
        return require("private-next-pages/nutritional-advisors/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nutritional-advisors"])
      });
    }
  